"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"));

var isURL = require('is-url');

var fileType = require('file-type');

var axios = require('axios');

var handleLang = function handleLang(modules) {
  return function (_ref) {
    var TessModule = _ref.TessModule,
        dataPath = _ref.dataPath,
        cachePath = _ref.cachePath,
        cacheMethod = _ref.cacheMethod,
        langCode = _ref.langCode;
    return function (data) {
      if (TessModule) {
        if (dataPath) {
          try {
            TessModule.FS.mkdir(dataPath);
          } catch (err) {// TODO: Do some error handling here.
          }
        }

        TessModule.FS.writeFile((dataPath || '.') + "/" + langCode + ".traineddata", data);
      }

      if (['write', 'refresh', undefined].includes(cacheMethod)) {
        return modules.writeCache((cachePath || '.') + "/" + langCode + ".traineddata", data).then(function () {
          return data;
        });
      }

      return data;
    };
  };
};

var loadAndGunzipFile = function loadAndGunzipFile(modules) {
  return function (_ref2) {
    var langPath = _ref2.langPath,
        cachePath = _ref2.cachePath,
        cacheMethod = _ref2.cacheMethod,
        _ref2$gzip = _ref2.gzip,
        gzip = _ref2$gzip === void 0 ? true : _ref2$gzip,
        options = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["langPath", "cachePath", "cacheMethod", "gzip"]);
    return function (lang) {
      var langCode = typeof lang === 'string' ? lang : lang.code;

      var handleTraineddata = function handleTraineddata(data) {
        var type = fileType(data);

        if (type !== null && type.mime === 'application/gzip') {
          return modules.gunzip(new Uint8Array(data));
        }

        return new Uint8Array(data);
      };

      var doHandleLang = handleLang(modules)((0, _objectSpread3.default)({
        cachePath: cachePath,
        cacheMethod: cacheMethod,
        langCode: langCode
      }, options));
      var readCache = modules.readCache;

      if (['refresh', 'none'].includes(cacheMethod)) {
        readCache = function readCache() {
          return Promise.resolve();
        };
      }

      return readCache((cachePath || '.') + "/" + langCode + ".traineddata").then(function (data) {
        if (typeof data === 'undefined') {
          return Promise.reject();
        }

        return doHandleLang(data);
      })
      /*
       * If not found in the cache
       */
      .catch(function () {
        if (typeof lang === 'string') {
          var fetchTrainedData = function fetchTrainedData(iLangPath) {
            return axios.get(iLangPath + "/" + langCode + ".traineddata" + (gzip ? '.gz' : ''), {
              responseType: 'arraybuffer'
            }).then(function (_ref3) {
              var data = _ref3.data;
              return new Uint8Array(data);
            }).then(handleTraineddata).then(doHandleLang);
          };
          /** When langPath is an URL, just do the fetch */


          if (isURL(langPath) || langPath.startsWith('chrome-extension://')
          /* for chrome extensions */
          ) {
              return fetchTrainedData(langPath);
            }
          /** When langPath is not an URL in Node.js environment */


          return modules.readCache(langPath + "/" + langCode + ".traineddata" + (gzip ? '.gz' : '')).then(handleTraineddata).then(doHandleLang);
        }

        return Promise.resolve(lang.data).then(handleTraineddata).then(doHandleLang);
      });
    };
  };
};
/**
 *
 * @name loadLang
 * @function load language(s) from local cache, download from remote if not in cache.
 * @param {object}   options
 * @param {array}    options.langs -
 *     langs to load.
 *     Each item in the array can be string (ex. 'eng') or object like:
 *      {
 *        code: 'eng',
 *        gzip: false,
 *        data: Uint8Array
 *      }
 * @param {object}   options.TessModule - TesseractModule
 * @param {string}   options.langPath - prefix path for downloading lang file
 * @param {string}   options.cachePath - path to find cache
 * @param {string}   options.dataPath - path to store data in mem
 * @param {boolean}  options.gzip -
 *     indicate whether to download gzip version from remote, default: true
 * @param {string} options.cacheMethod -
 *     method of cache invaliation, should one of following options:
 *       write: read cache and write back (default method)
 *       readOnly: read cache and not to write back
 *       refresh: not to read cache and write back
 *       none: not to read cache and not to write back
 *
 */


module.exports = function (modules) {
  return function (_ref4) {
    var langs = _ref4.langs,
        options = (0, _objectWithoutPropertiesLoose2.default)(_ref4, ["langs"]);
    return Promise.all((typeof langs === 'string' ? langs.split('+') : langs).map(loadAndGunzipFile(modules)(options)));
  };
};